import { useEffect } from 'react';

/**
 * Лёгкая шина для «обнови summary» между несвязанными деревьями компонентов
 * (карточка события → колокольчик в Header; заявка → badge в Sidebar).
 * Никаких данных в событии нет: получатель делает authoritative refetch.
 */
export const APP_EVENTS = {
  NOTIFICATIONS_REFRESH: 'notifications-refresh',
  CHANGE_REQUESTS_REFRESH: 'change-requests-refresh',
  // Правило сменило категорию: его события переехали между «Нарушениями» и
  // «Бизнес-метриками» — сводки и выбор правил в фильтрах перечитываются.
  RULE_CATEGORY_CHANGED: 'rule-category-changed',
};

export const emitAppEvent = (name) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(name));
};

export const useAppEvent = (name, handler) => {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    window.addEventListener(name, handler);
    return () => window.removeEventListener(name, handler);
  }, [name, handler]);
};
